import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import {store} from '../src/store/index';
import {Provider} from "react-redux";
import './index.css';
import {Toaster} from "react-hot-toast";
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_ID || 'GTM-XXXXXXXX'
}

TagManager.initialize(tagManagerArgs)

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <BrowserRouter>
                <App/>
            <Toaster/>
        </BrowserRouter>
    </Provider>
);

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker.js').then((registration) => {
        console.log('Service Worker registered:', registration);

        // check update SW
        registration.onupdatefound = () => {
            const newWorker = registration.installing;
            newWorker.onstatechange = () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                    console.log('new version of SW loaded');
                    newWorker.postMessage({ action: 'skipWaiting' });
                }
            };
        };
    });

    // waiting controller change and reload page ONCE
    let refreshing;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
            console.log('controller SW changed, reload page...');
            refreshing = true;
            window.location.reload();
        }
    });
}